import React from "react";
import { DisplayDate, DisplayDateTime } from '../../common/DisplayDate';

import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  BooleanField,
  EditButton,ShowButton,
  DeleteButton,
  ImageField,
  Filter,TopToolbar, 
  ReferenceInput,
  SearchInput,CreateButton, ExportButton,
  SelectField, TextInput, FilterButton, 
} from "react-admin";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { Authorizer } from "../../common/Authorizer";
import CDeleteButton from "../../common/CDeleteButton";
const ListActions = (props) => (
  <TopToolbar>
      {props.hasCreate && <CreateButton {...props} label="Upload File"/>}
      {props.hasExport && <ExportButton {...props}/>}
  </TopToolbar>
);

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <TextInput
      variant="outlined"
      label="Upload Number"
      source="daNo~like"
      alwaysOn
    />
    <TextInput
      variant="outlined"
      label="Upload File name"
      source="fileName~like"
      alwaysOn
    />

  </Filter>
);
export const ModuleList = (props) => {

  let propsObj = Authorizer(props);  
  return (
    <List  {...propsObj} exporter={propsObj.hasExport} actions={<ListActions {...propsObj}/>}
      sort={{ field: 'createdDate', order: 'DESC' }}
      filter={{importTypeId:209}}
    title="Update Order Ref Amount " filters={<Filters />}  >
      <Datagrid rowClick={false}>
        {/* {propsObj.hasEdit && <EditButton label="View Records"/>} */}
        {propsObj.hasEdit && <ShowButton label="View History"/>}
        {propsObj.hasDelete && <CDeleteButton {...props}/>}
        <TextField source="importOrderCode" label="Upload Number" />
        
        <TextField source="fileName" label="Upload File name" />
        <TextField source="status" label="Upload Status" />
        <ReferenceField source="createdBy" reference="users" label="Created By" link={false}>
          <TextField source="userName" />
        </ReferenceField>
        <DisplayDate source="createdDate" label="Created Date" locales="fr-FR" />
      </Datagrid>
    </List>
  );
};
